import sidebar from '@/config/sidebars/geogrids'
import createVueApp from '@/common/createApp'

Styxie.Initializers.PublicSearchTermsConfigs = {
  public_links: async(props) => {
    const { default: Component } = await import('@/vue_widgets/geogrids/scheduled/public_links/index.vue')
    createVueApp(Component, { props, sidebar })
  }
}
